<template>
    <div>
        <div class="clearbox"></div> 
        <img class="bannerbox"  src="../../static/images/banner2.jpg" /> 
        <div class="clearbox"></div>
        
        <div class="contentlist"> 
            <div class="index-width"> 
                <div class="listbox-left"> 
                    <div class="position">
                        <span>当前位置：<a ><router-link to="/">首页</router-link></a>&nbsp;&gt;&gt;&nbsp;<a @click="originRouter">合作伙伴</a> <template v-if="type">&nbsp;&gt;&gt;&nbsp;<a >{{typeTitle}}</a></template></span>
                    </div> 
                    <div class="Articlebox">
                        <h1>合作伙伴</h1>
                        <div class="a-text-c">
                            <div> 
                                <p><img src="http://picture.telluspowergreen.cn/uploads/common/1608195644794730.png" title="1608195644794730.png" alt="image.png"></p> 
                            </div> 
                        </div>
                    </div>

                    <!-- <div id="pages" class="text-c">
                        <el-pagination
                            background
                            layout="prev, pager, next"
                            :total="1">
                        </el-pagination>
                    </div>  -->

                </div> 
                
                <boxRight :key="Date.now()" :mainTitle="mainTitle" :liData="liData" @routerData="routerData"></boxRight>
            </div> 
        </div> 
        <div class="clearbox"></div> 
        <footerNew></footerNew>
    </div>
</template>

<script>
    import boxRight from '@/component/listBoxRight.vue'
    import footerNew from '@/component/footerNew.vue'
    export default {
        components:{
			boxRight,
            footerNew					
		},
        name: "news",
        data(){
            return{
                mainTitle:"合作伙伴",
                liData:[
                   
                ],
                listData:[
                   
                ],
                listDataNew:[],
                type:'',
                typeTitle:"",
            }
        },
        methods:{
            goDetails(e){
               
            },
            routerData(e){
               
            },
            originRouter(){
              
            },
            initData(id){
                
                
            },
        },
        watch:{
           
        },
        created(e){
            console.log(this.$route.query)
           
            
        }
    }
</script>

<style scoped>
.contentlist .Articlebox .a-text-c img {
    max-width: 700px;
    vertical-align: middle;
    border: 0;
}
.text-c {
    text-align: center;
}
#pages {
    padding: 14px 0 10px;
    font-family: 宋体;
    overflow: hidden;
    margin: 0 auto;
    width: 100%;
}
.contentlist .listbox-left ul.list_c li {
    width: 100%;
    float: left;
    line-height: 30px;
    box-sizing: border-box;
}
.contentlist .listbox-left ul.list_c li a {
    float: left;
    font-size: 14px;
    color: #333333;
}
.contentlist .listbox-left ul.list_c li span {
    color: #898989;
    font-size: 14px;
    float: right;
}
.contentlist .listbox-left ul.list_c li {
    width: 100%;
    float: left;
    line-height: 30px;
    box-sizing: border-box;
}
.contentlist .listbox-left ul.list_c {
    width: 100%;
    float: left;
    margin: 15px 0;
    overflow: hidden;
}
.detailClass{
    margin-top: 0px; 
    margin-bottom: 0px; 
    padding: 15px 0px 15px 65px; 
    border-width: 0px 0px 1px; 
    border-top-style: initial; 
    border-right-style: initial; 
    border-bottom-style: solid; 
    border-left-style: initial; 
    border-top-color: initial; 
    border-right-color: initial; 
    border-bottom-color: rgb(221, 221, 221); 
    border-left-color: initial; 
    border-image: initial; 
    font-size: 15px; 
    line-height: 28px;
}
.monClass{
    margin: 0px; 
    padding: 0px; 
    border: 0px; 
    width: 52px; 
    height: 28px; 
    display: block; 
    background-color: rgb(185, 185, 185); 
    text-align: center; 
    color: rgb(255, 255, 255); 
    font-size: 18px;
}
.ulClass{
    margin: 0px; 
    padding: 0px; 
    border: 0px; 
    /* width: 80%;  */
    /* float: right;  */
    position: relative;
}
.h2Class{
    /* margin: 0px 0px 0px; */
    margin-right: 50px;
    padding: 0px; 
    font-size: 18px !important; 
    width: 80px; 
    /* float: left;  */
    color: rgb(137, 137, 137); 
    line-height: 28px;
}
.contentlist .Articlebox .a-text-c {
    font-size: 14px;
    line-height: 28px;
    color: #333333;
    display: block;
    padding: 10px 20px;
    margin-top: 15px;
}
.contentlist .Articlebox h2 {
    font-size: 14px;
    color: #CCC;
    display: block;
    line-height: 22px;
    text-align: center;
}
.contentlist .Articlebox h1 {
    display: block;
    padding: 45px 0 5px;
    text-align: center;
    font-size: 19px;
}
.contentlist .Articlebox {
    width: 780px;
    float: left;
    min-height: 600px;
}
     ul, ol, li {
    list-style: none;
}
#pages {
    padding: 14px 0 10px;
    font-family: 宋体;
    overflow: hidden;
    margin: 0 auto;
    width: 100%;
}
.text-c {
    text-align: center;
}
.contentlist .listbox-left ul.list_c {
    width: 100%;
    float: left;
    margin: 15px 0;
    overflow: hidden;
}
.contentlist .listbox-left ul.list_c li a {
    float: left;
    font-size: 14px;
    color: #333333;
}
.contentlist .listbox-left ul.list_c li a:hover {
   
    color: #18D1BB;
}
.contentlist .listbox-left ul.list_c li span {
    color: #898989;
    font-size: 14px;
    float: right;
}
.contentlist .listbox-left ul.list_c li {
    width: 100%;
    float: left;
    line-height: 30px;
    box-sizing: border-box;
}
  .footerbox .fott-box2 {
    width: 100%;
    float: left;
    height: 50px;
}
.footerbox .fott-box2 .box2-right span {
    font-size: 14px;
    color: #181818;
    margin: 0 15px;
}
.footerbox .fott-box2 .box2-right {
    float: right;
    line-height: 50px;
    color: #e4e4e4;
    font-family: Tahoma;
}
  .contentlist .listbox-right {
    float: right;
    width: 200px;
}
.contentlist .listbox-right ul li a:hover, .contentlist .listbox-right ul li a.active {
    color: #18D1BB;
}
.contentlist .listbox-right ul li a {
    float: left;
    font-size: 14px;
    color: #000;
}
.contentlist .listbox-right ul li {
    width: 100%;
    float: left;
    line-height: 32px;
    box-sizing: border-box;
    padding-left: 15px;
    background: url(../../static/images/don.gif) no-repeat 5px center;
}
.footerbox {
    margin: 0 auto;
    width: 100%;
    overflow: hidden;
    background: url(../../static/images/bottom_bg.jpg) repeat-x left bottom;
}
.contentlist .listbox-right ul {
    width: 100%;
    float: left;
    margin: 15px 0;
    height: 128px;
}
.contentlist .listbox-right h2 span {
    line-height: 48px;
    font-size: 18px;
    color: #000;
    float: left;
    margin-left: 10px;
}
.contentlist .listbox-right h2 {
    width: 100%;
    height: 48px;
    background-color: #f8f8f8;
    padding: 0 10px;
    box-sizing: border-box;
}
  .contentlist .Articlebox {
    width: 780px;
    float: left;
    min-height: 600px;
}
div, form, ul, ol, li, span, p, dl, dt, dd, img {
    margin: 0;
    padding: 0;
    border: 0;
}
.contentlist .Articlebox .a-text-c {
    font-size: 14px;
    line-height: 28px;
    color: #333333;
    display: block;
    padding: 10px 20px;
    margin-top: 15px;
}
.contentlist .Articlebox h1 {
    display: block;
    padding: 45px 0 5px;
    text-align: center;
    font-size: 19px;
}
  a {
    color: #20366f;
    text-decoration: none;
}
  .position {
    width: 100%;
    float: left;
    border-bottom: 1px solid #dddddd;
    font-family: Tahoma;
    font-size: 14px;
    color: #666666;
    padding: 15px 0;
}
.position a, .position span {
    display: inline-block;
    font-size: 14px;
    color: #666666;
    margin: 0 5px;
}
    .contentlist .listbox-left {
        width: 760px;
        float: left;
    }
  .contentlist {
    margin: 30px auto 15px;
    overflow: hidden;
    width: 100%;
}
.index-width {
    width: 1000px;
    margin: 0 auto;
    position: relative;
}
  .bannerbox {
    margin: 0 auto;
    overflow: hidden;
    width: 100%;
    height: 208px;
    object-fit: cover;
}
  .clearbox {
    border-top: 1px solid transparent !important;
    margin-top: -1px !important;
    margin-top: 0px;
    clear: both;
    font-size: 0px;
    line-height: 0px;
    height: 0px;
    border: 0px;
    visibility: hidden;
}
    *{
      box-sizing: border-box;
      margin:0;
      padding:0;
    }
</style>